export default __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmWUlfCRc4EsA.woff2";